import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { NotificationsPresetEnum } from '../enums/notifications-preset.enum';

export class PatchNotificationPreferencesItemDto {
  isEnabled?: boolean;
  channel?: DataDispatchChannelEnum;
  preset?: NotificationsPresetEnum;
}
